
import Vue from "vue";
import { userMapGetters, userMapMutations } from "@/store/modules/user";
import {
  authMapGetters,
  authMapMutations,
  authMapState
} from "@/store/modules/auth";
import * as types from "@/store/mutation-types";
import { objectDifference } from "@/helpers";
import { has } from "lodash";
import { settingMapActions } from "@/store/modules/setting";

interface IData {
  message: string;
  error: string;
  loading: boolean;
  original: {
    isInEmergencyMaintenanceMode?: boolean;
    emergencyMaintenanceModeMessage?: string;
  };
  promptMessage: string;
}

export default Vue.extend({
  name: "UserAddNew",
  props: {},
  watch: {},
  data(): IData {
    return {
      message: "",
      error: "",
      loading: false,
      original: {},
      promptMessage: ""
    };
  },
  mounted() {
    this.original = { ...this.initData };
  },
  methods: {
    ...settingMapActions(["updateDefaultSettings"]),
    ...authMapMutations([types.SET_STATE]),
    ...userMapMutations({
      editField: "SET_USER_EDIT_FIELD"
    }),
    ...userMapMutations(["SET_EDIT_USER"]),
    setEmergencyMessage(message: string) {
      this.SET_STATE({
        key: "initData.emergencyMaintenanceModeMessage",
        value: message
      });
    },
    setEmergencyMaintenanceModeHandler(enabled: boolean) {
      this.SET_STATE({
        key: "initData.isInEmergencyMaintenanceMode",
        value: enabled
      });
    },
    async updateEmergencyModeData(): Promise<void> {
      const enableText =
        "You are about to enable emergency maintenance mode. This will prevent all users other than admin from accessing the website.";
      const disableText =
        "You are about to disable emergency maintenance mode. This will enable all users access to the website as usual";
      this.promptMessage = this.initData?.isInEmergencyMaintenanceMode
        ? enableText
        : disableText;
      if (has(this.updatedFields, "isInEmergencyMaintenanceMode")) {
        this.$modal.show("maintenanceModal");
      }
    },
    async doUpdate() {
      try {
        await this.updateDefaultSettings(this.updatedFields);
        this.original = { ...this.initData };
        this.$modal.hide("maintenanceModal");
        this.$appNotifySuccess(
          "Emergency maintenance mode data updated successfully"
        );
      } catch (error) {
        if (error !== "cancel") {
          this.$appNotify({
            message: error.message,
            type: "error",
            title: "Update Error"
          });
        }
        this.$bugSnagClient.notify(error);
      }
    }
  },
  computed: {
    ...authMapState(["initData"]),
    ...authMapGetters(["getCurrentUserId"]),
    ...userMapGetters(["getEditingUser", "getUserById"]),
    getSavedUser(): any {
      if (!this.getEditingUser) return {};
      const { _id } = this.getEditingUser;
      if (_id) {
        return this.getUserById(_id);
      }
      return {};
    },
    maintenanceModeText(): string {
      return this.original.isInEmergencyMaintenanceMode
        ? "emergencyMaintenanceEnabledHeader"
        : "emergencyMaintenanceDisabledHeader";
    },
    updatedFields(): any {
      const edited = this.initData;
      const original = this.original;
      return edited && original ? objectDifference(edited, original) : {};
    }
  }
});
